export default "__VITE_ASSET__845e8bab__"